import * as Vue from 'vue'

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

export default {
    config: (targetId: string, configParams: any) => {
        if (window.gtag) {
            //CHECK REF COOKIE
            let cookie_lastref = (Vue as any).cookie?.get("MMD_LastRef");
            if (cookie_lastref) {
                configParams.dimension1 = cookie_lastref.toLowerCase();
            }

            window.gtag('config', targetId, configParams);
        }
    },
    set: (setParams: any) => {
        if (window.gtag) {
            window.gtag('set', setParams);
        }
    },
    event: (eventName: string, eventParams: any) => {
        if (window.gtag) {
            //CHECK REF COOKIE
            let cookie_lastref = (Vue as any).cookie?.get("MMD_LastRef");
            if (cookie_lastref) {
                eventParams.dimension1 = cookie_lastref.toLowerCase();
            }

            window.gtag('event', eventName, eventParams);
        }
    }
}